
import { ROLE_ESHOP, ROLE_PRICELIST } from '~/constants/roles.js'

export default {
    props: {
        items: '',
        itemName: '',
        itemPath: '',
        isSubmenuActive: false,
    },
    data() {
        return {
            roles: this.$auth.user?.Role,
        }
    },
    methods: {
        checkOrderRoles(item, roles) {
            const orderSubPaths = ['orders', 'order-statistics', 'order-documents', 'order-documents']

            return orderSubPaths.includes(item.attributes[0].value.toLowerCase()) && roles.includes('hcp-orders')
        },
        checkPricelistRoles(roles) {
            return roles.includes(ROLE_ESHOP) || roles.includes(ROLE_PRICELIST)
        },
        filterSubItems(items, roles) {
            return items
                .map((item) => {
                    if (item.name === '/pricelists' && !this.checkPricelistRoles(roles)) {
                        return null
                    }
                    return item
                })
                .filter(Boolean)
        },
        isUrl(str) {
            /* eslint-disable no-useless-escape */
            const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
            return regexp.test(str)
        },
        invokeExternalUrl(url) {
            window.open(url, '_blank', 'noreferrer')
        },
    },
}
